/** A generated file: what the wizard shows, copies and downloads. */
export interface GeneratedFile {
  /** File name as it should be saved on site. */
  name: string;
  content: string;
  /** One line: where it goes / what to do with it. */
  note?: string;
}

/** XML text content. */
export const xml = (s: string) =>
  s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');

/** A YAML scalar, double-quoted when it needs to be. */
export const yaml = (s: string) =>
  /^[\w./:@-]+$/.test(s) && !/^(true|false|null|yes|no|~|\d.*)$/i.test(s) ? s : JSON.stringify(s);

/** A `.env` value: quoted when it holds spaces, quotes, `#` or `$`. */
export const env = (s: string) => (/[\s"'#$\\]/.test(s) ? JSON.stringify(s) : s);

/** A PowerShell single-quoted string. */
export const ps = (s: string) => `'${s.replace(/'/g, "''")}'`;

/** Pretty JSON with a trailing newline. */
export const json = (o: unknown) => `${JSON.stringify(o, null, 2)}\n`;
